module.exports = __webpack_public_path__ + "img/people_sll.a48c0178.png";